<div class="app-main__inner dashboard-page">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon bg-mean-fruit rounded-circle">
          <i class="pe-7s-note2 text-white"></i>
        </div>
        <div>
          Production Dashboard
          <div class="page-title-subheading">Live shop-floor status.</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Filter -->
  <div class="row">
    <div class="col-12">
      <div class="mb-2 card dashboard-filter-card">
        <div class="dashboard-filter-body">
          <div class="dashboard-filter-field">
            <label>Product</label>
            <select class="form-select" [(ngModel)]="filterForm.productId">
              <option *ngFor="let product of products" [value]="product._id">{{ product.name }}</option>
            </select>
          </div>
          <div class="dashboard-filter-field dashboard-filter-field-narrow">
            <label>Period</label>
            <select class="form-select" [(ngModel)]="filterForm.periodType">
              <option value="month">Month</option>
              <option value="day">Daily</option>
            </select>
          </div>
          <ng-container *ngIf="filterForm.periodType === 'month'">
            <div class="dashboard-filter-field dashboard-filter-field-narrow">
              <label>Start Month</label>
              <input class="form-control" type="month" [(ngModel)]="filterForm.startMonth" />
            </div>
            <div class="dashboard-filter-field dashboard-filter-field-narrow">
              <label>End Month</label>
              <input class="form-control" type="month" [(ngModel)]="filterForm.endMonth" />
            </div>
          </ng-container>
          <ng-container *ngIf="filterForm.periodType === 'day'">
            <div class="dashboard-filter-field dashboard-filter-field-narrow">
              <label>From</label>
              <input class="form-control" type="date" [(ngModel)]="filterForm.startDate" />
            </div>
            <div class="dashboard-filter-field dashboard-filter-field-narrow">
              <label>To</label>
              <input class="form-control" type="date" [(ngModel)]="filterForm.endDate" />
            </div>
          </ng-container>
          <button class="btn btn-primary dashboard-filter-submit" [disabled]="loading" (click)="applyFilter()">
            <span class="spinner-border spinner-border-sm mr-1" *ngIf="loading"></span>
            <i class="fa fa-check mr-1" *ngIf="!loading"></i>
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Alerts -->
  <div class="row" *ngIf="alerts.length > 0">
    <div class="col-12">
      <div class="accordion mb-2" id="alertsAccordion">
        <div class="accordion-item">
          <h2 class="accordion-header" id="alertsHeading">
            <button
              class="accordion-button alerts-accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#alertsCollapse"
              aria-expanded="true"
              aria-controls="alertsCollapse"
            >
              <span class="alerts-header-icon"><i class="fa fa-exclamation-triangle"></i></span>
              Alerts
              <span class="badge alerts-count-badge ml-2">{{ alerts.length }}</span>
            </button>
          </h2>
          <div id="alertsCollapse" class="accordion-collapse collapse show" aria-labelledby="alertsHeading" data-bs-parent="#alertsAccordion">
            <div class="accordion-body p-0">
              <ul class="list-group list-group-flush alerts-scroll">
                <li
                  class="list-group-item alert-row"
                  [class.alert-row-danger]="alert.type === 'behindTarget' || alert.type === 'downtime'"
                  [class.alert-row-warning]="alert.type === 'blockedStep'"
                  [class.alert-row-info]="alert.type === 'idleOperator'"
                  [class.alert-row-success]="alert.type === 'downtimeResolved'"
                  *ngFor="let alert of alerts"
                >
                  <span class="alert-row-icon">
                    <i
                      class="fa"
                      [ngClass]="{
                        'fa-wrench': alert.type === 'downtime',
                        'fa-arrow-down': alert.type === 'behindTarget',
                        'fa-ban': alert.type === 'blockedStep',
                        'fa-user-clock': alert.type === 'idleOperator',
                        'fa-check-circle': alert.type === 'downtimeResolved'
                      }"
                    ></i>
                  </span>
                  <div class="alert-row-body">
                    <ng-container *ngIf="alert.type === 'downtime'; else resolvedOrGenericAlert">
                      <div class="downtime-alert">
                        <div class="downtime-alert-top">
                          <span class="badge badge-dark mr-2">Downtime</span>
                          <span class="badge badge-secondary mr-2">{{ alert.productName ? 'Product' : 'Machine' }}</span>
                          <strong>{{ alert.productName || alert.machineTypeName || 'Machine' }}</strong>
                          <span class="text-muted" *ngIf="alert.stepName">&nbsp;&rarr; {{ alert.stepName }}</span>
                        </div>
                        <div class="downtime-alert-tags">
                          <span class="badge badge-light mr-1" *ngIf="alert.productName && alert.machineTypeName">{{ alert.machineTypeName }}</span>
                          <span class="badge badge-light mr-1" *ngIf="alert.machineName">{{ alert.machineName }}</span>
                          <span class="downtime-alert-reason">{{ alert.reasonName }}</span>
                        </div>
                        <div class="downtime-alert-note" *ngIf="alert.note">"{{ alert.note }}"</div>
                        <div class="downtime-alert-meta">
                          Reported by {{ alert.operatorName }}
                          <span class="dot-sep" *ngIf="alert.createdAt">&middot;</span>
                          <span *ngIf="alert.createdAt">{{ formatTime(alert.createdAt) }}</span>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #resolvedOrGenericAlert>
                      <ng-container *ngIf="alert.type === 'downtimeResolved'; else genericAlert">
                        <span class="badge alert-type-badge badge-success mr-2">Resolved</span>
                        {{ alert.message }}
                      </ng-container>
                    </ng-template>
                    <ng-template #genericAlert>
                      <span
                        class="badge alert-type-badge mr-2"
                        [class.badge-danger]="alert.type === 'behindTarget'"
                        [class.badge-warning]="alert.type === 'blockedStep'"
                        [class.badge-info]="alert.type === 'idleOperator'"
                      >
                        {{ alert.type | camelToTitle }}
                      </span>
                      {{ alert.message }}
                    </ng-template>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- KPI cards -->
  <div class="dashboard-section-label">Overview</div>
  <div class="kpi-web-row">
    <div class="kpi-web-card kpi-web-target">
      <div class="kpi-web-icon"><i class="fa fa-bullseye"></i></div>
      <div class="kpi-web-text">
        <div class="kpi-web-value">{{ target }}</div>
        <div class="kpi-web-label">Target</div>
      </div>
    </div>
    <div class="kpi-web-card kpi-web-finished">
      <div class="kpi-web-icon"><i class="fa fa-check-circle"></i></div>
      <div class="kpi-web-text">
        <div class="kpi-web-value">{{ completed }}</div>
        <div class="kpi-web-label">Finished Units</div>
      </div>
    </div>
    <div class="kpi-web-card kpi-web-pending">
      <div class="kpi-web-icon"><i class="fa fa-hourglass-half"></i></div>
      <div class="kpi-web-text">
        <div class="kpi-web-value">{{ pending }}</div>
        <div class="kpi-web-label">Pending</div>
      </div>
    </div>
    <div class="kpi-web-card kpi-web-efficiency">
      <div class="kpi-web-icon"><i class="fa fa-tachometer-alt"></i></div>
      <div class="kpi-web-text">
        <div class="kpi-web-value">{{ efficiencyPct }}%</div>
        <div class="kpi-web-label">Efficiency</div>
      </div>
    </div>
    <div class="kpi-web-card kpi-web-actions">
      <div class="kpi-web-icon"><i class="fa fa-bolt"></i></div>
      <div class="kpi-web-text">
        <div class="kpi-web-value">{{ stepActions }}</div>
        <div class="kpi-web-label">Total Steps Completed</div>
      </div>
    </div>
  </div>

  <!-- Charts -->
  <div class="dashboard-section-label">Trends</div>
  <div class="row">
    <div class="col-12">
      <div class="mb-2 card">
        <div class="card-header chart-card-header d-flex justify-content-between align-items-center">
          <div class="chart-header-text">
            <div class="chart-header-row">
              <span class="chart-header-title">{{ activityChartTitle }}</span>
              <span class="badge badge-primary chart-header-badge" *ngIf="selectedProductName">{{ selectedProductName }}</span>
              <span class="chart-header-range">{{ appliedRangeLabel }}</span>
            </div>
          </div>
          <select class="form-select form-select-sm chart-type-select" [(ngModel)]="activityChartType" (ngModelChange)="refreshActivityChartRenderData()">
            <option value="bar" *ngIf="appliedFilter.periodType !== 'month'">Bar</option>
            <option value="line">Line</option>
          </select>
        </div>
        <div class="card-body chart-card-body" *ngIf="hasActivityData">
          <canvas baseChart [data]="activityChartRenderData" [options]="activityChartOptions" [type]="activityChartType"></canvas>
        </div>
        <div class="card-body text-center text-muted" *ngIf="!hasActivityData">No activity for the selected product/period.</div>
      </div>
    </div>
    <div class="col-12">
      <div class="mb-2 card">
        <div class="card-header chart-card-header d-flex justify-content-between align-items-center">
          <div class="chart-header-text">
            <div class="chart-header-row">
              <span class="chart-header-title">Step-wise Completion (per Product)</span>
              <span class="badge badge-primary chart-header-badge" *ngIf="selectedProductName">{{ selectedProductName }}</span>
              <span class="chart-header-range">{{ appliedRangeLabel }}</span>
            </div>
            <div class="chart-header-hint" *ngIf="hasStepData">Click a bar to see who completed it.</div>
          </div>
          <select class="form-select form-select-sm chart-type-select" [(ngModel)]="stepChartType" (ngModelChange)="refreshStepChartRenderData()">
            <option value="bar">Bar</option>
            <option value="doughnut">Doughnut</option>
            <option value="pie">Pie</option>
          </select>
        </div>
        <div class="card-body chart-card-body chart-card-body-wide" *ngIf="hasStepData">
          <canvas
            baseChart
            [data]="stepChartRenderData"
            [options]="stepChartOptions"
            [type]="stepChartType"
            (chartClick)="onStepChartClick($event)"
          ></canvas>
        </div>
        <div class="card-body text-center text-muted" *ngIf="!hasStepData">No activity for the selected product/period.</div>
      </div>
    </div>
    <!-- Step-wise Completion (per Operator) — commented out for now, not needed. The underlying
    operatorStepWise data is still fetched/kept (see dashboard.component.ts) since the step-detail
    modal opened from the "per Product" chart above still uses it.
    <div class="col-12">
      <div class="mb-3 card">
        <div class="card-header">Step-wise Completion (per Operator)</div>
        <div class="card-body chart-card-body chart-card-body-wide">
          <canvas baseChart [data]="operatorStepChartData" [options]="stepChartOptions" type="bar"></canvas>
        </div>
      </div>
    </div>
    -->
  </div>

  <!-- Activity — commented out for now, not needed.
  <div class="dashboard-section-label">Activity</div>
  <div class="row">
    <div class="col-12">
      <div class="accordion" id="dashboardActivityAccordion">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingLiveActivity">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseLiveActivity"
              aria-expanded="true"
              aria-controls="collapseLiveActivity"
            >
              Live Activity
              <span class="badge badge-secondary ml-2">{{ activityFeed.length }}</span>
            </button>
          </h2>
          <div
            id="collapseLiveActivity"
            class="accordion-collapse collapse show"
            aria-labelledby="headingLiveActivity"
            data-bs-parent="#dashboardActivityAccordion"
          >
            <div class="accordion-body p-0">
              <div class="scroll-area-sm">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item" *ngFor="let item of activityFeed">
                    <strong>{{ item.time }}</strong> — {{ item.productName }} / {{ item.stepName }} ({{ item.mode | camelToTitle }})
                  </li>
                  <li class="list-group-item text-muted" *ngIf="activityFeed.length === 0">Waiting for live updates…</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  -->

  <!-- Step detail modal — operator-wise breakdown for whichever bar was clicked above -->
  <div class="modal fade" id="stepDetailModal" tabindex="-1" aria-hidden="true" appAppendToBody>
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" *ngIf="selectedStepDetail">{{ selectedStepDetail.productName }} — {{ selectedStepDetail.stepName }}</h5>
          <select class="form-select form-select-sm chart-type-select mr-2" [(ngModel)]="stepDetailChartType" (ngModelChange)="refreshStepDetailChartRenderData()">
            <option value="bar">Bar</option>
            <option value="doughnut">Doughnut</option>
            <option value="pie">Pie</option>
          </select>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="chart-card-body chart-card-body-wide">
            <canvas baseChart [data]="stepDetailChartRenderData" [options]="stepDetailChartOptions" [type]="stepDetailChartType"></canvas>
          </div>
          <p class="text-center text-muted mb-0" *ngIf="stepDetailChartData.labels?.length === 0">No completions for this step yet.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
